import styled, { css } from "styled-components";

const LableStyled = styled.label`
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.2s ease-in-out;
    position: absolute;
    left: 2rem;
    font-size: 1.4rem;
    cursor: text;
    pointer-events: none;
    z-index: 10;
    margin: 0;

    &.label__with__symbol {
        left: 6rem;
    }

    ${props => {
        return (
            props.checkbox &&
            css`
                transform: translateY(-50%);
            `
        );
    }}
`;

export default LableStyled;
